import React, { useState } from 'react';
import { Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { Account } from '@/model';
import { PersonalDataTab } from './tabs/PersonalDataTab';
import { LocalizationTab } from './tabs/LocalizationTab';
import { ContactTab } from './tabs/ContactTab';
import { useTranslation } from 'react-i18next';
// import { NotificationsTab } from './tabs/NotificationsTab';

export interface AccountDetailTabsProps {
  isLoading?: boolean;
  item: Account;
}

export const AccountDetailTabsComponent = ({ isLoading, item }: AccountDetailTabsProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const { t } = useTranslation();

  return (
    <Tabs borderRadius='card' shadow='md' onChange={tabIndex => setTabIndex(tabIndex)}>
      <Flex overflow='auto'>
        <TabList whiteSpace='nowrap' flex={1} borderTopWidth='8px' borderTopRadius='8px' borderTopColor='gray.200'>
          <Tab
            color='text.main'
            _selected={{
              position: 'relative',
              '::before': {
                content: '""',
                display: 'block',
                width: '100%',
                height: '8px',
                borderTopLeftRadius: 8,
                backgroundColor: 'brand.500',
                position: 'absolute',
                top: '-8px',
                zIndex: 99,
              },
            }}
          >
            {t('pages.accountdetail.components.tabs.tabs.personal_data')}
          </Tab>
          <Tab
            color='text.main'
            _selected={{
              position: 'relative',
              '::before': {
                content: '""',
                display: 'block',
                width: '100%',
                height: '8px',
                backgroundColor: 'brand.500',
                position: 'absolute',
                top: '-8px',
                zIndex: 99,
              },
            }}
          >
            {t('pages.accountdetail.components.tabs.tabs.localization')}
          </Tab>
          <Tab
            color='text.main'
            _selected={{
              position: 'relative',

              '&::before': {
                content: '""',
                display: 'block',
                width: '100%',
                height: '8px',
                backgroundColor: 'brand.500',
                position: 'absolute',
                top: '-8px',
                zIndex: 99,
              },
            }}
          >
            {t('pages.accountdetail.components.tabs.tabs.contact')}
          </Tab>
          {/* <Tab
            color='text.main'
            _selected={{
              position: 'relative',
              '::before': {
                content: '""',
                display: 'block',
                width: '100%',
                height: '8px',
                backgroundColor: 'brand.500',
                position: 'absolute',
                top: '-8px',
                zIndex: 99,

                '@media (max-width: 564px)': {
                  borderTopRightRadius: '8px',
                },
              },
            }}
          >
            Notificações
          </Tab> */}
        </TabList>
      </Flex>

      <TabPanels>
        <TabPanel>
          <PersonalDataTab isLoading={isLoading} item={item} />
        </TabPanel>
        <TabPanel>
          <LocalizationTab isLoading={isLoading} item={item} />
        </TabPanel>
        <TabPanel>
          <ContactTab isLoading={isLoading} item={item} />
        </TabPanel>
        {/* <TabPanel>
          <NotificationsTab isLoading={isLoading} userId={item?.uuid as string} isTabSelected={tabIndex === 3} />
        </TabPanel> */}
      </TabPanels>
    </Tabs>
  );
};

export const AccountDetailTabs = React.memo(AccountDetailTabsComponent);
